export default __webpack_public_path__ + "static/media/Logo-Reserva.618ffcd3.svg";